module.exports = __webpack_public_path__ + "img/social-media-display-mitsu.63f23a51.png";